/*
 * @Descripttion:
 * @Author: baiyang
 * @Date: 2021-12-21 14:16:46
 * @LastEditors: baiyang
 * @LastEditTime: 2022-03-14 14:27:14
 */
import Vue from 'vue'

import {
  PullRefresh,
  Button,
  NumberKeyboard,
  Checkbox,
  CheckboxGroup,
  Form,
  ActionSheet,
  Overlay,
  DatetimePicker,
  Picker,
  Popup,
  NoticeBar,
  Field,
  Switch,
  RadioGroup,
  Radio,
  SwipeCell,
  Icon,
  Tag,
  Cell,
  List,
  Search,
  Dialog,
  PasswordInput,
  Tab,
  Tabs,
  Sticky,
  Popover,
  Loading
} from 'vant'
import 'vant/lib/pull-refresh/style'
import 'vant/lib/number-keyboard/style'
import 'vant/lib/index.css'
Vue.component('VanRadioGroup', RadioGroup)
Vue.component('VanRadio', Radio)
Vue.component('VanForm', Form)
Vue.component('VanPullRefresh', PullRefresh)
Vue.component('VanButton', Button)
Vue.component('VanActionSheet', ActionSheet)
Vue.component('VanOverlay', Overlay)
Vue.component('VanDatetimePicker', DatetimePicker)
Vue.component('VanPicker', Picker)
Vue.component('VanPopup', Popup)
Vue.component('VanSearch', Search)
Vue.component('VanField', Field)
Vue.component('VanNumberKeyboard', NumberKeyboard)
Vue.component('VanNoticeBar', NoticeBar)
Vue.component('VanForm', Form)
Vue.component('VanCheckbox', Checkbox)
Vue.component('VanCheckboxGroup', CheckboxGroup)
Vue.component('VanSwitch', Switch)
Vue.component('VanSwipeCell', SwipeCell)
Vue.component('VanIcon', Icon)
Vue.component('VanTag', Tag)
Vue.component('VanCell', Cell)
Vue.component('VanList', List)
// Dialog 导出的是函数式 API；模板组件必须用 Dialog.Component，否则会被当成异步组件工厂，进页即弹出空「确认」框
Vue.component('VanDialog', Dialog.Component)
Vue.component('VanPasswordInput', PasswordInput)
Vue.component('VanTab', Tab)
Vue.component('VanTabs', Tabs)
Vue.component('VanSticky', Sticky)
Vue.component('VanPopover', Popover)
Vue.component('VanLoading', Loading)
